export var WebSpotlightModels;
(function (WebSpotlightModels) {
    class WebSpotlightStatus {
        constructor(data) {
            this.enabled = data.enabled;
            this.rootType = data.rootType;
            this._raw = data._raw;
        }
    }
    WebSpotlightModels.WebSpotlightStatus = WebSpotlightStatus;
})(WebSpotlightModels || (WebSpotlightModels = {}));
//# sourceMappingURL=web-spotlight.models.js.map